import React, { useState, useEffect } from 'react';
import Consultation from '../pages/Consultation'; 
import SEO from "../components/SEO";

const team = [
  { name: 'Dr. Arjun Reddy',   role: 'Founder & CEO',                    img: '👨‍⚕️' },
  { name: 'Priya Nair',        role: 'Chief Infrastructure Officer',      img: '👩‍💼' },
  { name: 'Rajesh Kumar',      role: 'Head of Medical Projects',          img: '👨‍🔧' },
  { name: 'Sneha Patel',       role: 'Lead NABH Consultant',              img: '👩‍💻' },
];

const milestones = [
  { year: '2017', event: 'Founded in Vijayawada — focused on hospital interior turnkey projects' },
  { year: '2019', event: 'Expanded across Andhra Pradesh, 25+ hospitals successfully delivered' },
  { year: '2021', event: 'Launched in-house modular OT and ICU manufacturing unit' },
  { year: '2023', event: 'Crossed 50 hospital projects — from clinics to multi-specialty complexes' },
  { year: '2024', event: 'Extended presence across Telangana, added NABH consulting practice' },
  { year: '2025', event: '100+ hospitals built and counting across Telangana & Andhra Pradesh' },
];

const stats = [
  { v: '8+',  l: 'Years' },
  { v: '150+', l: 'Engineers' },
  { v: '100+', l: 'Hospitals' },
  { v: '2',    l: 'States Served' },
];

const values = [
  { icon: '🏥', title: 'Patient-Centric Design',   desc: 'Every layout, every corridor, every room is planned around the comfort and safety of patients and medical staff.' },
  { icon: '✅', title: 'NABH Compliance First',     desc: 'We embed compliance into construction — no last-minute audits, no rework. Just clean certifications the first time.' },
  { icon: '🔩', title: 'End-to-End Execution',      desc: 'From civil and MEP to medical gases, furniture, and equipment — one partner, one accountability, zero gaps.' },
  { icon: '🌱', title: 'Sustainable Infrastructure',desc: 'Energy-efficient systems, eco-friendly materials and responsible waste management on every site.' },
];

const services = [
  'Modular Operation Theatres',
  'ICU Setup & Design',
  'Medical Gas Pipeline Systems',
  'HVAC & Clean Room Engineering',
  'NABH Consulting & Compliance',
  'Biomedical Equipment Supply',
  'Hospital Electrical (LT & HT)',
  'Fire & Safety Systems',
];

export default function About() {
  const [showConsultation, setShowConsultation] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  const openConsultation = () => setShowConsultation(true);
  const closeConsultation = () => setShowConsultation(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return (
     <>
    <SEO/>
    <div className="about-page">
      <style>{`
        .about-page {
          padding-top: 68px;
          font-family: 'Inter', 'Montserrat', sans-serif;
        }
        @media (max-width: 900px) {
          .about-page { padding-top: 60px; }
        }
        @media (max-width: 480px) {
          .about-page { padding-top: 56px; }
        }

        .about-modal-overlay {
          position: fixed; inset: 0; z-index: 2000;
          background: rgba(0,0,0,0.65);
          backdrop-filter: blur(5px);
          display: flex; align-items: center; justify-content: center;
          padding: 1rem;
        }
        .about-modal-inner {
          position: relative; width: 100%
          max-height: 90vh; overflow-y: auto; border-radius: 18px;
        }
        .about-modal-close {
          position: absolute; top: 14px; right: 16px; z-index: 10;
          background: #262E63; border: none; color: #fff;
          width: 32px; height: 32px; border-radius: 50%;
          font-size: 20px; cursor: pointer;
          display: flex; align-items: center; justify-content: center;
          line-height: 1;
        }
        .about-modal-close:hover { background: #3A4060; }
      `}</style>

      {/* ── Hero ── */}
      <div style={{
        background: '#343F86',
        padding: isMobile ? '56px 20px' : '100px 40px',
        position: 'relative',
        overflow: 'hidden',
      }}>
        {/* subtle grid overlay */}
        <div style={{
          position: 'absolute', inset: 0,
          backgroundImage: 'linear-gradient(rgba(255,255,255,0.04) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.04) 1px, transparent 1px)',
          backgroundSize: '48px 48px',
        }} />
        {/* ash glow */}
        <div style={{
          position: 'absolute', top: -120, left: -80,
          width: 500, height: 500,
          background: 'radial-gradient(circle, rgba(180,180,180,0.10) 0%, transparent 70%)',
          pointerEvents: 'none',
        }} />

        <div style={{ maxWidth: 1200, margin: '0 auto', position: 'relative', zIndex: 2 }}>
          <div >
            <div style={{
              display: 'inline-block',
              fontFamily: "'Montserrat', 'Inter', sans-serif",
              fontSize: 11, fontWeight: 600, letterSpacing: 3,
              textTransform: 'uppercase', color: '#7FD0DA',
              background: 'rgba(255,255,255,0.08)', padding: '6px 14px',
              borderRadius: 4, marginBottom: isMobile ? 16 : 24,
            }}>
              Our Story
            </div>
            <h1 style={{
              fontFamily: "'Montserrat', 'Inter', sans-serif",
              fontSize: isMobile ? 32 : 'clamp(32px, 5vw, 56px)',
              color: '#fff', fontWeight: 700, lineHeight: 1.15, marginBottom: isMobile ? 16 : 24,
            }}>
              Building the Hospitals<br />Telangana & Andhra Pradesh Deserve
            </h1>
            <p style={{ fontFamily: "'Inter', 'Montserrat', sans-serif", fontSize: isMobile ? 15 : 16, color: '#A7ACBD', lineHeight: 1.8, }}>
              PR Hospital Designers was founded with one mission: to bring world-class hospital infrastructure to every corner of
              Telangana and Andhra Pradesh. From modular OTs and ICUs to full NABH-compliant turnkey hospitals —
              we've delivered 100+ healthcare facilities that save lives every single day.
            </p>
          </div>
        </div>
      </div>

      {/* ── Stats Bar ── */}
      <div style={{ background: '#3A4060' }}>
        <div style={{
          maxWidth: 1200, margin: '0 auto', padding: isMobile ? '0 12px' : '0 24px',
          display: 'grid', gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(4, 1fr)',
        }}>
          {stats.map((s, i) => (
            <div key={i} style={{
              padding: isMobile ? '18px 12px' : '28px 24px', textAlign: 'center',
              borderRight: isMobile
                ? (i % 2 === 0 ? '1px solid rgba(255,255,255,0.25)' : 'none')
                : (i < 3 ? '1px solid rgba(255,255,255,0.25)' : 'none'),
              borderBottom: isMobile && i < 2 ? '1px solid rgba(255,255,255,0.25)' : 'none',
            }}>
              <div style={{ fontFamily: "'Montserrat', 'Inter', sans-serif", fontSize: isMobile ? 24 : 32, fontWeight: 700, color: '#fff', lineHeight: 1 }}>{s.v}</div>
              <div style={{ fontFamily: "'Inter', 'Montserrat', sans-serif", fontSize: 11, color: 'rgba(255,255,255,0.75)', letterSpacing: 1.5, textTransform: 'uppercase', marginTop: 6 }}>{s.l}</div>
            </div>
          ))}
        </div>
      </div>

      {/* ── Mission / Vision ── */}
      <section style={{ background: '#fff', padding: isMobile ? '48px 20px' : '96px 24px' }}>
        <div style={{ maxWidth: 1200, margin: '0 auto' }}>
          <div style={{
            display: isMobile ? 'flex' : 'grid',
            flexDirection: isMobile ? 'column' : undefined,
            gridTemplateColumns: isMobile ? undefined : '1fr 1fr',
            gap: isMobile ? 32 : 72,
            alignItems: 'center',
          }}>
            <div>
              <div style={{ fontFamily: "'Montserrat', 'Inter', sans-serif", fontSize: 11, fontWeight: 600, letterSpacing: 3, textTransform: 'uppercase', color: '#2F8A98', marginBottom: 16 }}>
                Who We Are
              </div>
              <h2 style={{ fontFamily: "'Montserrat', 'Inter', sans-serif", fontSize: isMobile ? 26 : 'clamp(26px,3.5vw,40px)', fontWeight: 700, color: '#343F86', marginBottom: 20, lineHeight: 1.2 }}>
                Engineering Healing<br />Spaces Since 2017
              </h2>
              <p style={{ fontFamily: "'Inter', 'Montserrat', sans-serif", fontSize: isMobile ? 15 : 16, color: '#5B6072', lineHeight: 1.8, marginBottom: 18 }}>
                At PR Hospital Designers, we don't just construct hospital buildings — we create ecosystems where clinical excellence thrives.
                Our team of engineers, architects, NABH consultants, and biomedical specialists work together on every project
                across Telangana and Andhra Pradesh.
              </p>
              <p style={{ fontFamily: "'Inter', 'Montserrat', sans-serif", fontSize: isMobile ? 15 : 16, color: '#5B6072', lineHeight: 1.8, marginBottom: isMobile ? 24 : 36 }}>
                With our in-house modular manufacturing unit, we fabricate OTs, ICUs, and clean rooms to international standards —
                backed by our industry-first 10-year structural warranty.
              </p>

              {/* Services Pills */}
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10 }}>
                {services.map((s, i) => (
                  <span key={i} style={{
                    fontFamily: "'Inter', 'Montserrat', sans-serif",
                    fontSize: 13, fontWeight: 500, color: '#343F86',
                    background: '#ECEEF6', border: '1px solid #CDD1E0',
                    padding: '6px 14px', borderRadius: 100,
                  }}>
                    {s}
                  </span>
                ))}
              </div>
            </div>

            {/* Photo Grid */}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: isMobile ? 10 : 14, width: '100%' }}>
              {[
                { label: 'OT Assembly Unit',     bg: '#E1E3EE' },
                { label: 'ICU Setup',             bg: '#E1E3EE' },
                { label: 'NABH Audit Ready',      bg: '#E1E3EE' },
                { label: 'On-Site Installation',  bg: '#E1E3EE' },
              ].map((item, i) => (
                <div key={i} style={{
                  height: isMobile ? 130 : 190,
                  background: item.bg,
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  borderRadius: 10, border: '1px solid rgba(0,0,0,0.08)',
                }}>
                  <span style={{ fontFamily: "'Inter', 'Montserrat', sans-serif", fontSize: isMobile ? 12 : 13, color: '#8A8F9C', letterSpacing: 1, textAlign: 'center', padding: '0 8px' }}>{item.label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ── Core Values ── */}
      <section style={{ background: '#ECEEF6', padding: isMobile ? '48px 20px' : '96px 24px' }}>
        <div style={{ maxWidth: 1200, margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: isMobile ? 32 : 56 }}>
            <div style={{ fontFamily: "'Montserrat', 'Inter', sans-serif", fontSize: 11, fontWeight: 600, letterSpacing: 3, textTransform: 'uppercase', color: '#2F8A98', marginBottom: 12 }}>Core Values</div>
            <h2 style={{ fontFamily: "'Montserrat', 'Inter', sans-serif", fontSize: isMobile ? 26 : 'clamp(26px,3.5vw,40px)', fontWeight: 700, color: '#343F86' }}>What Drives Every Project</h2>
          </div>
          <div style={{
            display: 'grid',
            gridTemplateColumns: isMobile ? '1fr' : 'repeat(4, 1fr)',
            gap: isMobile ? 16 : 24,
          }}>
            {values.map((v, i) => (
              <div key={i} style={{
                background: '#fff', padding: isMobile ? '28px 22px' : '36px 24px',
                border: '1px solid #CDD1E0', borderRadius: 12,
                textAlign: 'center', transition: 'box-shadow 0.2s',
              }}>
                <div style={{ fontSize: 40, marginBottom: 16 }}>{v.icon}</div>
                <div style={{ fontFamily: "'Montserrat', 'Inter', sans-serif", fontSize: isMobile ? 18 : 20, fontWeight: 600, color: '#343F86', marginBottom: 12 }}>{v.title}</div>
                <div style={{ fontFamily: "'Inter', 'Montserrat', sans-serif", fontSize: 13, color: '#5B6072', lineHeight: 1.7 }}>{v.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Timeline ── */}
      <section style={{ background: '#fff', padding: isMobile ? '48px 20px' : '96px 24px' }}>
        <div style={{ maxWidth: 800, margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: isMobile ? 32 : 56 }}>
            <div style={{ fontFamily: "'Montserrat', 'Inter', sans-serif", fontSize: 11, fontWeight: 600, letterSpacing: 3, textTransform: 'uppercase', color: '#2F8A98', marginBottom: 12 }}>Our Journey</div>
            <h2 style={{ fontFamily: "'Montserrat', 'Inter', sans-serif", fontSize: isMobile ? 26 : 'clamp(26px,3.5vw,40px)', fontWeight: 700, color: '#343F86' }}>Years of Building Healthcare</h2>
          </div>
          <div style={{ position: 'relative' }}>
            <div style={{
              position: 'absolute',
              left: isMobile ? 44 : 90,
              top: 0, bottom: 0, width: 2, background: '#CDD1E0',
            }} />
            {milestones.map((m, i) => (
              <div key={i} style={{
                display: 'flex', gap: isMobile ? 16 : 32, alignItems: 'flex-start',
                marginBottom: isMobile ? 28 : 40, position: 'relative',
              }}>
                <div style={{ width: isMobile ? 44 : 90, textAlign: 'right', flexShrink: 0, paddingTop: 2 }}>
                  <span style={{ fontFamily: "'Montserrat', 'Inter', sans-serif", fontSize: isMobile ? 13 : 18, fontWeight: 600, color: '#343F86' }}>{m.year}</span>
                </div>
                <div style={{
                  width: 14, height: 14, background: '#3A4060',
                  borderRadius: '50%', flexShrink: 0, marginTop: 5,
                  border: '3px solid #fff', outline: '2px solid #3A4060', zIndex: 1, position: 'relative',
                }} />
                <div style={{ flex: 1 }}>
                  <div style={{ fontFamily: "'Inter', 'Montserrat', sans-serif", fontSize: isMobile ? 13.5 : 15, color: '#262E63', lineHeight: 1.65 }}>{m.event}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Team ── */}
      <section style={{ background: '#ECEEF6', padding: isMobile ? '48px 20px' : '96px 24px' }}>
        <div style={{ maxWidth: 1200, margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: isMobile ? 32 : 56 }}>
            <div style={{ fontFamily: "'Montserrat', 'Inter', sans-serif", fontSize: 11, fontWeight: 600, letterSpacing: 3, textTransform: 'uppercase', color: '#2F8A98', marginBottom: 12 }}>Leadership</div>
            <h2 style={{ fontFamily: "'Montserrat', 'Inter', sans-serif", fontSize: isMobile ? 26 : 'clamp(26px,3.5vw,40px)', fontWeight: 700, color: '#343F86' }}>Meet Our Team</h2>
          </div>
          <div style={{
            display: 'grid',
            gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(4, 1fr)',
            gap: isMobile ? 14 : 24,
          }}>
            {team.map((t, i) => (
              <div key={i} style={{
                background: '#fff', border: '1px solid #CDD1E0',
                borderRadius: 12, overflow: 'hidden', textAlign: 'center',
              }}>
                <div style={{
                  height: isMobile ? 120 : 180,
                  background: `hsl(0, 0%, ${88 - i * 6}%)`,
                  display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: isMobile ? 42 : 60,
                }}>
                  {t.img}
                </div>
                <div style={{ padding: isMobile ? '14px 10px' : '20px' }}>
                  <div style={{ fontFamily: "'Montserrat', 'Inter', sans-serif", fontSize: isMobile ? 13 : 15, fontWeight: 600, color: '#343F86', marginBottom: 4 }}>{t.name}</div>
                  <div style={{ fontFamily: "'Inter', 'Montserrat', sans-serif", fontSize: isMobile ? 11.5 : 13, color: '#8A8F9C' }}>{t.role}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── CTA ── */}
      <section style={{  background: '#2f397a', padding: isMobile ? '48px 20px' : '96px 24px', textAlign: 'center', position: 'relative', overflow: 'hidden' }}>
        <div style={{
          position: 'absolute', bottom: -160, right: -100,
          width: 480, height: 480,
          background: '#2f397a',
          pointerEvents: 'none',
        }} />
        <div style={{ maxWidth: 600, margin: '0 auto', position: 'relative', zIndex: 2 }}>
          <div style={{ fontFamily: "'Montserrat', 'Inter', sans-serif", fontSize: 11, fontWeight: 600, letterSpacing: 3, textTransform: 'uppercase', color: '#7FD0DA', marginBottom: isMobile ? 14 : 20 }}>
            Let's Build Together
          </div>
          <h2 style={{ fontFamily: "'Montserrat', 'Inter', sans-serif", fontSize: isMobile ? 26 : 'clamp(28px,4vw,40px)', fontWeight: 700, color: '#fff', marginBottom: isMobile ? 12 : 16, lineHeight: 1.2 }}>
            Ready to Build Your Hospital?
          </h2>
          <p style={{ fontFamily: "'Inter', 'Montserrat', sans-serif", fontSize: isMobile ? 15 : 16, color: '#A7ACBD', marginBottom: isMobile ? 28 : 40, lineHeight: 1.75 }}>
            100+ hospitals across Telangana &amp; Andhra Pradesh trust PR Hospital Designers. Let's make yours the next success story.
          </p>
          <div style={{ display: 'flex', gap: 16, justifyContent: 'center', flexWrap: 'wrap' }}>
            <button
              onClick={openConsultation}
              style={{
                background: '#fff', color: '#343F86', border: 'none',
                borderRadius: 10, padding: isMobile ? '13px 28px' : '14px 32px',
                fontFamily: "'Montserrat', 'Inter', sans-serif", fontSize: 14, fontWeight: 700,
                cursor: 'pointer', transition: 'all 0.2s', width: isMobile ? '100%' : 'auto',
              }}
              onMouseEnter={e => e.currentTarget.style.background = '#CDD1E0'}
              onMouseLeave={e => e.currentTarget.style.background = '#fff'}
            >
              Get Free Consultation
            </button>
          </div>
        </div>
      </section>

      {/* ── Consultation Modal ── */}
      {showConsultation && (
        <div
          className="about-modal-overlay"
          onClick={(e) => { if (e.target === e.currentTarget) closeConsultation(); }}
        >
          <div className="about-modal-inner">
            <button className="about-modal-close" onClick={closeConsultation} aria-label="Close consultation form">
              ×
            </button>
            <Consultation />
          </div>
        </div>
      )}

    </div>
    </>
  );
}